import { Button, DatePicker, Drawer, Form, Input, InputNumber, Radio, Space, Steps, Tag, Tooltip } from 'antd';
import AccountReadinessStatus from './AccountReadinessStatus';
import DouyinAccountCheckButton from './DouyinAccountCheckButton';
import KuaishouAccountCheckButton from './KuaishouAccountCheckButton';
import XhsAccountCheckButton from './XhsAccountCheckButton';
import { getAccountPlatformLabel } from '../utils/accountReadiness';

const PublishTimeDrawer = ({
  open,
  publishSubmitting,
  publishType,
  setPublishType,
  publishTimeForm,
  currentPublishRecord,
  selectedAccounts,
  onClose,
  onBack,
  onConfirm,
  immediatePublishBlocked,
  scheduledPublishBlocked,
  renderQuotaTooltip,
}) => (
  <Drawer
    title="选择发布时间"
    placement="right"
    width={600}
    onClose={onClose}
    open={open}
    mask
    maskStyle={{ backdropFilter: 'none', WebkitBackdropFilter: 'none' }}
    footer={(
      <div style={{ textAlign: 'right', padding: '10px 0' }}>
        <Space>
          <Button onClick={onBack} disabled={publishSubmitting}>
            返回
          </Button>
          <Tooltip
            title={
              publishType === 'immediate' && immediatePublishBlocked
                ? renderQuotaTooltip('monthly_publishes')
                : publishType === 'scheduled' && scheduledPublishBlocked
                  ? renderQuotaTooltip('tasks')
                  : null
            }
          >
            <span>
              <Button
                type="primary"
                onClick={onConfirm}
                loading={publishSubmitting}
                disabled={
                  (publishType === 'immediate' && immediatePublishBlocked)
                  || (publishType === 'scheduled' && scheduledPublishBlocked)
                }
              >
                确认
              </Button>
            </span>
          </Tooltip>
        </Space>
      </div>
    )}
  >
    <Steps
      size="small"
      current={publishSubmitting ? 2 : 1}
      style={{ marginBottom: 16 }}
      items={[
        { title: '选账号', status: 'finish' },
        { title: '选方式', status: publishSubmitting ? 'finish' : 'process' },
        { title: '提交', status: publishSubmitting ? 'process' : 'wait' },
        { title: '查看状态', status: 'wait' },
      ]}
    />

    <Form form={publishTimeForm} layout="vertical">
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div style={{
          padding: '16px',
          background: '#f5f5f5',
          borderRadius: '4px',
          marginBottom: '24px',
        }}
        >
          <div style={{ marginBottom: '12px', fontSize: '14px', color: '#333' }}>
            您将发送"<span style={{ fontWeight: 600 }}>{currentPublishRecord?.title || '内容'}</span>"于以下账号：
          </div>
          {selectedAccounts.map((account) => (
            <div key={account.account_id} style={{
              marginBottom: '8px',
              padding: '12px',
              background: '#fff',
              borderRadius: '4px',
            }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: 8 }}>
                <Tag color="blue">
                  {getAccountPlatformLabel(account)}
                </Tag>
                <span style={{ marginRight: '8px' }}>账号ID: {account.account_id}</span>
                <span>账号名: {account.account_name}</span>
              </div>
              <div style={{ marginBottom: 8 }}>
                <AccountReadinessStatus account={account} />
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Space size="small">
                  <DouyinAccountCheckButton
                    account={account}
                    label="检测账号"
                    buttonProps={{ style: { padding: '0 4px' } }}
                  />
                  <KuaishouAccountCheckButton
                    account={account}
                    label="检测账号"
                    buttonProps={{ style: { padding: '0 4px' } }}
                  />
                  <XhsAccountCheckButton
                    account={account}
                    label="检测账号"
                    restartMcp
                    buttonProps={{ style: { padding: '0 4px' } }}
                  />
                </Space>
              </div>
            </div>
          ))}
        </div>

        <div>
          <div style={{ marginBottom: '16px', fontWeight: 600, fontSize: '14px' }}>
            选择发布方式：
          </div>
          <Radio.Group
            value={publishType}
            onChange={(e) => {
              setPublishType(e.target.value);
              if (e.target.value === 'immediate') {
                publishTimeForm.setFieldsValue({ task_name: '', scheduled_time: null });
              }
            }}
            style={{ width: '100%' }}
          >
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
              <Radio value="immediate" style={{ fontSize: '14px' }}>
                立刻发布
              </Radio>
              <Radio value="scheduled" style={{ fontSize: '14px' }}>
                定时发布
              </Radio>
            </Space>
          </Radio.Group>
        </div>

        {publishType === 'scheduled' && (
          <>
            <Form.Item
              label="任务名称"
              name="task_name"
              rules={[{ required: true, message: '请输入任务名称' }]}
            >
              <Input placeholder="请输入任务名称" />
            </Form.Item>
            <Form.Item
              label={selectedAccounts?.length === 1 ? '本次最多发布条数' : '每账号最多发布条数'}
              name="max_items_per_account_per_run"
              initialValue={1}
              rules={[{ required: true, message: '请输入条数' }]}
            >
              <InputNumber min={1} max={50} style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item
              label="选择发布时间"
              name="scheduled_time"
              rules={[{ required: true, message: '请选择发布时间' }]}
            >
              <DatePicker
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                style={{ width: '100%' }}
                placeholder="请选择发布时间"
              />
            </Form.Item>
          </>
        )}
      </Space>
    </Form>
  </Drawer>
);

export default PublishTimeDrawer;
